import axios from "../utils/http";
import utils from "../utils";

const dataUpload = {
  insertCollectItem(params) {
    return axios.post(
      "/api/insertCollectItem",
      utils.postParamsArrayToJsonString({ ...params })
    );
  },
  listEnergyCode() {
    return axios.post("/api/listEnergyCode");
  },

  listEnterpriseInfo() {
    return axios.post("/api/listEnterpriseInfo");
  },

  selectDockingPointInfo(codeId, companyId) {
    return axios.post(
      "/api/listEnterpriseInfo",
      utils.postParamsArrayToJsonString({ codeId, companyId })
    );
  },

  uploadConfigData(enterpriseCode, region) {
    return axios.post(
      "/api/upload/configData",
      utils.postParamsArrayToJsonString({ enterpriseCode, region })
    );
  },

  setDockingState(enterpriseCode, state) {
    return axios.post(
      "/api/setDockingState",
      utils.postParamsArrayToJsonString({ enterpriseCode, state })
    );
  },

  /**
   * 新增公司
   */
  insertEnterpriseInfo(params) {
    return axios.post(
      "/api/insertEnterpriseInfo",
      utils.postParamsArrayToJsonString({ ...params })
    );
  },

  manualStatisticHourDataByCompanyId(companyId, startDate, endDate) {
    return axios.post(
      "/api/statistic/manualStatisticHourDataByCompanyId",
      utils.postParamsArrayToJsonString({ companyId, startDate, endDate })
    );
  },

  manualStatisticDayDataByCompanyId(companyId, startDate, endDate) {
    return axios.post(
      "/api/statistic/manualStatisticDayDataByCompanyId",
      utils.postParamsArrayToJsonString({ companyId, startDate, endDate })
    );
  },

  manualStatisticMonthDataByCompanyId(companyId, startDate, endDate) {
    return axios.post(
      "/api/statistic/manualStatisticMonthDataByCompanyId",
      utils.postParamsArrayToJsonString({ companyId, startDate, endDate })
    );
  },

  manualUploadDataByCompanyId(companyId) {
    return axios.post(
      "/api/statistic/manualUploadDataByCompanyId",
      utils.postParamsArrayToJsonString({ companyId })
    );
  },

};

export default dataUpload;
